import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../pages/listings.module.css';

const formatPrice = (priceInCents, currency) =>
  typeof priceInCents === 'number'
    ? new Intl.NumberFormat('en-UK', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(priceInCents / 100)
    : '-';

const PlansTable = ({ plans, onDeactivate }) => {
  const navigate = useNavigate();

  return (
    <table className='table table-striped table-hover'>
      <thead>
        <tr className={styles.headings}>
          <th scope='col'>#</th>
          <th scope='col'>Name</th>
          <th scope='col'>Price</th>
          <th scope='col'>Max RFQs / Month</th>
          <th scope='col'>Active</th>
          <th scope='col'>Actions</th>
        </tr>
      </thead>
      <tbody>
        {plans.length > 0 ? (
          plans.map((plan, index) => (
            <tr key={plan.id} className={styles.rows}>
              <th scope='row'>{index + 1}</th>
              <td>{plan.name}</td>
              <td>{formatPrice(plan.price, plan.currency)}</td>
              <td>{plan.maxRfqPerMonth}</td>
              <td>{plan.active ? 'Yes' : 'No'}</td>
              <td>
                <button
                  type='button'
                  className='btn btn-sm btn-outline-primary me-2'
                  onClick={() => navigate(`/quantila/plans/update/${plan.id}`)}
                  disabled
                >
                  <FontAwesomeIcon icon='pen-square' /> Edit
                </button>
                <button
                  type='button'
                  className='btn btn-sm btn-outline-danger'
                  disabled
                  onClick={() => onDeactivate(plan)}
                >
                  <FontAwesomeIcon icon='trash' /> Deactivate
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={6}>No plans to display ...</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default PlansTable;
